import { useNavigate } from "react-router-dom";


export const GratitudeBlock = () => {
  const history = useNavigate();

  const clickHandler = () => {
    history("/");
  };

  return (
    <div className="card">
      <div>Спасибо за обратную связь!</div>
      <div className="buttons">
        <button onClick={clickHandler}>Другие инструкции</button>
      </div>
    </div>
  );
};
// export const GratitudeBlock: FC<Props> = ({ company_id }) => {
//   const history = useNavigate();

//   const clickHandler = () => {
//     history('/' + company_id);
//   };

//   return (
//     <div>
//       <div>Спасибо за обратную связь!</div>
//       <div className="buttons">
//         <button onClick={clickHandler}>Другие инструкции</button>
//       </div>
//     </div>
//   );
// };
